function RoundStepper({
  currentStep,
  stepInfo,
}: {
  currentStep: number;
  stepInfo: any;
}) {
  const totalStep = stepInfo.length;
  const radius = 35;
  const stroke = 4;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const progress = (currentStep / totalStep) * 100;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="min-[600px]:hidden flex gap-x-5 items-center mb-6">
      <div className="relative size-[70px]">
        <svg
          height={radius * 2}
          width={radius * 2}
          className="transform -rotate-90"
        >
          <circle
            stroke="#D1D5DB"
            fill="white"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <circle
            stroke="#374151"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            style={{
              transition: "stroke-dashoffset 0.6s ease-in-out",
            }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-medium text-gray-700">
            {currentStep} of {totalStep}
          </span>
        </div>
      </div>
      <div className="grid gap-y-1.5">
        <p className="text-gray-700 font-semibold">
          {stepInfo[currentStep - 1]?.label}
        </p>
        {currentStep < stepInfo.length && (
          <p className="text-gray-400 text-sm">
            <span>Next :</span>
            {stepInfo[currentStep]?.label}
          </p>
        )}
      </div>
    </div>
  );
}

export default RoundStepper;
